export const translations = {
  en: {
    // Landing Page
    landing: {
      tagline: "Wholesale & B2B Distribution Management Software",
      heroTitle1: "Wholesale Distribution Management",
      heroTitle2: "Software",
      heroTitle3: "for Distributors",
      heroDescription: "LitSpark Wholesale Distribution Software helps B2B distributors, stockists, and suppliers manage their entire operation from one powerful dashboard.",
      tryDemo: "Try Demo",
      knowMore: "Know More about LitSpark",
      featuresTitle: "Powerful Features Designed for Modern Wholesale Distribution",
      features: {
        routeManagement: {
          title: "Route Logistics & Dispatch Management",
          desc: "Optimize multi-stop delivery routes, assign field drivers and sales reps to territories, and monitor delivery progress across locations."
        },
        shopManagement: {
          title: "Client & Credit Management",
          desc: "Manage buyer records, customized credit limits, outstanding invoices, and returnable assets such as pallets, crates, racks, or containers."
        },
        salesmanTracking: {
          title: "Sales Rep & Collection Tracking",
          desc: "Let field reps record deliveries, capture cash or digital payments, and submit route settlements with fewer reconciliation errors."
        },
        purchaseManagement: {
          title: "Vendor Purchase & Procurement",
          desc: "Record inbound shipments, monitor stock arrivals, track vendor payment schedules, and control inventory valuation."
        },
        expenseTracking: {
          title: "Expense Control & Cost Allocation",
          desc: "Track fleet fuel, handling fees, staff wages, warehouse overheads, and daily operational expenditure."
        },
        transactionReports: {
          title: "Comprehensive Financial Reports",
          desc: "Generate ledger balances, customer histories, sales rep performance reports, and invoice aging analysis with detailed filters."
        },
        dailySummary: {
          title: "Daily Operations Dashboard",
          desc: "View sales volume, dispatch status, field cash collections, expenses, and net profit from one interface."
        },
        profitLoss: {
          title: "Automated Profit & Loss Tracking",
          desc: "Understand your financial health with continuous P&L statements built for low-margin, high-volume trading."
        },
        initialLoading: {
          title: "Loading & Stock Reconciliation",
          desc: "Track warehouse inventory movement, cross-check loaded stock against field returns, and reduce inventory leakage."
        }
      },
      footer: {
        copyright: "All rights reserved.",
        visitLitSpark: "Visit LitSpark Solutions"
      }
    },
    // Login Page
    login: {
      title: "LitSpark Egg Distributors Demo",
      subtitle: "Complete management solution for egg distribution businesses",
      featuresTitle: "Dashboard Features",
      features: [
        "Route Management",
        "Shop & Customer Tracking",
        "Salesman Performance",
        "Purchase & Inventory",
        "Expense Tracking",
        "Transaction Reports",
        "Daily Summary",
        "Profit & Loss Analytics"
      ],
      tryDemo: "Try the Demo",
      signInSubtitle: "Sign in to explore all the features",
      emailLabel: "Email Address",
      emailPlaceholder: "Enter your email",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter your password",
      signIn: "Sign In",
      signingIn: "Signing in...",
      whatsappText: "Want to try the demo? Send us a WhatsApp message!",
      whatsappButton: "Send WhatsApp"
    },
    // Language Modal
    languageModal: {
      title: "Select Your Language",
      subtitle: "Choose your preferred language",
      disclaimer: "Note: Translations for Kannada and Hindi are auto-generated. If you notice any mistakes, please let us know so we can improve them.",
      continue: "Continue",
      changeLanguage: "Change Language"
    }
  },
  kn: {
    // Landing Page - Kannada
    landing: {
      tagline: "ಸಗಟು ಮತ್ತು B2B ವಿತರಣೆ ನಿರ್ವಹಣಾ ಸಾಫ್ಟ್‌ವೇರ್",
      heroTitle1: "ಸಗಟು ವಿತರಣೆ ನಿರ್ವಹಣೆ",
      heroTitle2: "ಸಾಫ್ಟ್‌ವೇರ್",
      heroTitle3: "ವಿತರಕರಿಗಾಗಿ",
      heroDescription: "LitSpark ಸಗಟು ವಿತರಣೆ ಸಾಫ್ಟ್‌ವೇರ್ B2B ವಿತರಕರು, ಸ್ಟಾಕಿಸ್ಟ್‌ಗಳು ಮತ್ತು ಪೂರೈಕೆದಾರರು ತಮ್ಮ ಸಂಪೂರ್ಣ ಕಾರ್ಯಾಚರಣೆಯನ್ನು ಒಂದೇ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಿಂದ ನಿರ್ವಹಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
      tryDemo: "ಡೆಮೊ ಪ್ರಯತ್ನಿಸಿ",
      knowMore: "LitSpark ಬಗ್ಗೆ ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
      featuresTitle: "ಆಧುನಿಕ ಸಗಟು ವಿತರಣೆಗಾಗಿ ಶಕ್ತಿಶಾಲಿ ವೈಶಿಷ್ಟ್ಯಗಳು",
      features: {
        routeManagement: {
          title: "ಮಾರ್ಗ ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಮತ್ತು ಡಿಸ್ಪ್ಯಾಚ್",
          desc: "ಬಹು-ನಿಲುಗಡೆ ವಿತರಣಾ ಮಾರ್ಗಗಳನ್ನು ಸುಧಾರಿಸಿ, ಕ್ಷೇತ್ರ ಸಿಬ್ಬಂದಿಯನ್ನು ಪ್ರದೇಶಗಳಿಗೆ ನಿಯೋಜಿಸಿ ಮತ್ತು ವಿತರಣಾ ಪ್ರಗತಿಯನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡಿ."
        },
        shopManagement: {
          title: "ಗ್ರಾಹಕ ಮತ್ತು ಕ್ರೆಡಿಟ್ ನಿರ್ವಹಣೆ",
          desc: "ಖರೀದಿದಾರರ ದಾಖಲೆಗಳು, ಕ್ರೆಡಿಟ್ ಮಿತಿಗಳು, ಬಾಕಿ ಇನ್‌ವಾಯ್ಸ್‌ಗಳು ಮತ್ತು ಮರುಬಳಕೆ ಮಾಡಬಹುದಾದ ವಿತರಣಾ ಸ್ವತ್ತುಗಳನ್ನು ನಿರ್ವಹಿಸಿ."
        },
        salesmanTracking: {
          title: "ಮಾರಾಟ ಪ್ರತಿನಿಧಿ ಮತ್ತು ಸಂಗ್ರಹಣೆ ಟ್ರ್ಯಾಕಿಂಗ್",
          desc: "ಕ್ಷೇತ್ರ ಪ್ರತಿನಿಧಿಗಳು ವಿತರಣೆ, ನಗದು ಅಥವಾ ಡಿಜಿಟಲ್ ಪಾವತಿ ಮತ್ತು ಮಾರ್ಗ ಸೆಟ್ಲ್‌ಮೆಂಟ್‌ಗಳನ್ನು ತಕ್ಷಣ ದಾಖಲಿಸಲು ಅವಕಾಶ ನೀಡಿ."
        },
        purchaseManagement: {
          title: "ಮಾರಾಟಗಾರ ಖರೀದಿ ಮತ್ತು ಸಂಗ್ರಹಣೆ",
          desc: "ಒಳಬರುವ ಸಾಗಣೆ, ಸ್ಟಾಕ್ ಆಗಮನ, ಪೂರೈಕೆದಾರರ ಪಾವತಿ ವೇಳಾಪಟ್ಟಿ ಮತ್ತು ದಾಸ್ತಾನು ಮೌಲ್ಯವನ್ನು ನಿರ್ವಹಿಸಿ."
        },
        expenseTracking: {
          title: "ವೆಚ್ಚ ನಿಯಂತ್ರಣ ಮತ್ತು ಹಂಚಿಕೆ",
          desc: "ವಾಹನ ಇಂಧನ, ಹ್ಯಾಂಡ್ಲಿಂಗ್ ಶುಲ್ಕ, ಸಿಬ್ಬಂದಿ ವೇತನ, ಗೋದಾಮು ಮತ್ತು ದೈನಂದಿನ ಕಾರ್ಯಾಚರಣಾ ವೆಚ್ಚಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ."
        },
        transactionReports: {
          title: "ಸಮಗ್ರ ಹಣಕಾಸು ವರದಿಗಳು",
          desc: "ಲೆಡ್ಜರ್ ಬ್ಯಾಲೆನ್ಸ್, ಗ್ರಾಹಕ ಇತಿಹಾಸ, ಮಾರಾಟ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ಇನ್‌ವಾಯ್ಸ್ ಏಜಿಂಗ್ ವರದಿಗಳನ್ನು ರಚಿಸಿ."
        },
        dailySummary: {
          title: "ದೈನಂದಿನ ಕಾರ್ಯಾಚರಣೆ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
          desc: "ಮಾರಾಟ, ಡಿಸ್ಪ್ಯಾಚ್, ಕ್ಷೇತ್ರ ಸಂಗ್ರಹಣೆ, ವೆಚ್ಚ ಮತ್ತು ನಿವ್ವಳ ಲಾಭವನ್ನು ಒಂದೇ ಸ್ಥಳದಲ್ಲಿ ವೀಕ್ಷಿಸಿ."
        },
        profitLoss: {
          title: "ಸ್ವಯಂಚಾಲಿತ ಲಾಭ ಮತ್ತು ನಷ್ಟ ಟ್ರ್ಯಾಕಿಂಗ್",
          desc: "ಕಡಿಮೆ ಮಾರ್ಜಿನ್, ಹೆಚ್ಚಿನ ವಹಿವಾಟಿನ ವ್ಯಾಪಾರಕ್ಕಾಗಿ ನಿರಂತರ P&L ವರದಿಗಳೊಂದಿಗೆ ಹಣಕಾಸಿನ ಸ್ಥಿತಿಯನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ."
        },
        initialLoading: {
          title: "ಲೋಡಿಂಗ್ ಮತ್ತು ಸ್ಟಾಕ್ ಹೊಂದಾಣಿಕೆ",
          desc: "ಗೋದಾಮಿನ ದಾಸ್ತಾನು ಚಲನವಲನವನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ, ಲೋಡ್ ಮಾಡಿದ ಸ್ಟಾಕ್ ಅನ್ನು ಕ್ಷೇತ್ರದ ವಾಪಸಾತಿಯೊಂದಿಗೆ ಪರಿಶೀಲಿಸಿ ಮತ್ತು ಸೋರಿಕೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಿ."
        }
      },
      footer: {
        copyright: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
        visitLitSpark: "LitSpark Solutions ಗೆ ಭೇಟಿ ನೀಡಿ"
      }
    },
    // Login Page - Kannada
    login: {
      title: "LitSpark ಮೊಟ್ಟೆ ವಿತರಕರ ಡೆಮೊ",
      subtitle: "ಮೊಟ್ಟೆ ವಿತರಣಾ ವ್ಯವಹಾರಗಳಿಗೆ ಸಂಪೂರ್ಣ ನಿರ್ವಹಣಾ ಪರಿಹಾರ",
      featuresTitle: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ವೈಶಿಷ್ಟ್ಯಗಳು",
      features: [
        "ಮಾರ್ಗ ನಿರ್ವಹಣೆ",
        "ಅಂಗಡಿ ಮತ್ತು ಗ್ರಾಹಕ ಟ್ರ್ಯಾಕಿಂಗ್",
        "ಮಾರಾಟಗಾರ ಕಾರ್ಯಕ್ಷಮತೆ",
        "ಖರೀದಿ ಮತ್ತು ದಾಸ್ತಾನು",
        "ವೆಚ್ಚ ಟ್ರ್ಯಾಕಿಂಗ್",
        "ವಹಿವಾಟು ವರದಿಗಳು",
        "ದೈನಂದಿನ ಸಾರಾಂಶ",
        "ಲಾಭ ಮತ್ತು ನಷ್ಟ ವಿಶ್ಲೇಷಣೆ"
      ],
      tryDemo: "ಡೆಮೊ ಪ್ರಯತ್ನಿಸಿ",
      signInSubtitle: "ಎಲ್ಲಾ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಅನ್ವೇಷಿಸಲು ಸೈನ್ ಇನ್ ಮಾಡಿ",
      emailLabel: "ಇಮೇಲ್ ವಿಳಾಸ",
      emailPlaceholder: "ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ",
      passwordLabel: "ಪಾಸ್‌ವರ್ಡ್",
      passwordPlaceholder: "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
      signIn: "ಸೈನ್ ಇನ್",
      signingIn: "ಸೈನ್ ಇನ್ ಆಗುತ್ತಿದೆ...",
      whatsappText: "ಡೆಮೊ ಪ್ರಯತ್ನಿಸಲು ಬಯಸುವಿರಾ? ನಮಗೆ WhatsApp ಸಂದೇಶ ಕಳುಹಿಸಿ!",
      whatsappButton: "WhatsApp ಕಳುಹಿಸಿ"
    },
    // Language Modal - Kannada
    languageModal: {
      title: "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
      subtitle: "ನಿಮ್ಮ ಆದ್ಯತೆಯ ಭಾಷೆಯನ್ನು ಆರಿಸಿ",
      disclaimer: "ಗಮನಿಸಿ: ಕನ್ನಡ ಮತ್ತು ಹಿಂದಿ ಅನುವಾದಗಳು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಲ್ಪಟ್ಟಿವೆ. ನೀವು ಯಾವುದೇ ತಪ್ಪುಗಳನ್ನು ಗಮನಿಸಿದರೆ, ದಯವಿಟ್ಟು ನಮಗೆ ತಿಳಿಸಿ ಇದರಿಂದ ನಾವು ಅವುಗಳನ್ನು ಸುಧಾರಿಸಬಹುದು.",
      continue: "ಮುಂದುವರಿಸಿ",
      changeLanguage: "ಭಾಷೆ ಬದಲಾಯಿಸಿ"
    }
  },
  hi: {
    // Landing Page - Hindi
    landing: {
      tagline: "थोक और B2B वितरण प्रबंधन सॉफ्टवेयर",
      heroTitle1: "थोक वितरण प्रबंधन",
      heroTitle2: "सॉफ्टवेयर",
      heroTitle3: "वितरकों के लिए",
      heroDescription: "LitSpark थोक वितरण सॉफ्टवेयर B2B वितरकों, स्टॉकिस्टों और आपूर्तिकर्ताओं को एक डैशबोर्ड से अपना संपूर्ण संचालन प्रबंधित करने में मदद करता है।",
      tryDemo: "डेमो आज़माएं",
      knowMore: "LitSpark के बारे में और जानें",
      featuresTitle: "आधुनिक थोक वितरण के लिए शक्तिशाली सुविधाएं",
      features: {
        routeManagement: {
          title: "रूट लॉजिस्टिक्स और डिस्पैच प्रबंधन",
          desc: "मल्टी-स्टॉप डिलीवरी रूट बेहतर बनाएं, फील्ड स्टाफ को क्षेत्रों में नियुक्त करें और डिलीवरी की प्रगति देखें।"
        },
        shopManagement: {
          title: "ग्राहक और क्रेडिट प्रबंधन",
          desc: "खरीदार रिकॉर्ड, कस्टम क्रेडिट सीमा, बकाया इनवॉइस और लौटाए जाने वाले डिलीवरी एसेट प्रबंधित करें।"
        },
        salesmanTracking: {
          title: "सेल्स प्रतिनिधि और कलेक्शन ट्रैकिंग",
          desc: "फील्ड प्रतिनिधियों को डिलीवरी, नकद या डिजिटल भुगतान और रूट सेटलमेंट तुरंत दर्ज करने दें।"
        },
        purchaseManagement: {
          title: "वेंडर खरीद और प्रोक्योरमेंट",
          desc: "इनबाउंड शिपमेंट, स्टॉक आगमन, वेंडर भुगतान शेड्यूल और इन्वेंट्री मूल्यांकन प्रबंधित करें।"
        },
        expenseTracking: {
          title: "खर्च नियंत्रण और लागत आवंटन",
          desc: "फ्लीट ईंधन, हैंडलिंग शुल्क, कर्मचारियों के वेतन, वेयरहाउस और दैनिक परिचालन खर्च ट्रैक करें।"
        },
        transactionReports: {
          title: "व्यापक वित्तीय रिपोर्ट",
          desc: "लेजर बैलेंस, ग्राहक इतिहास, बिक्री प्रदर्शन और इनवॉइस एजिंग रिपोर्ट तैयार करें।"
        },
        dailySummary: {
          title: "दैनिक संचालन डैशबोर्ड",
          desc: "बिक्री, डिस्पैच, फील्ड कलेक्शन, खर्च और शुद्ध लाभ एक ही इंटरफेस में देखें।"
        },
        profitLoss: {
          title: "स्वचालित लाभ और हानि ट्रैकिंग",
          desc: "कम मार्जिन, अधिक मात्रा वाले व्यापार के लिए निरंतर P&L रिपोर्ट से वित्तीय स्थिति समझें।"
        },
        initialLoading: {
          title: "लोडिंग और स्टॉक मिलान",
          desc: "वेयरहाउस इन्वेंट्री मूवमेंट ट्रैक करें, लोडेड स्टॉक को फील्ड रिटर्न से मिलाएं और इन्वेंट्री लीकेज घटाएं।"
        }
      },
      footer: {
        copyright: "सर्वाधिकार सुरक्षित।",
        visitLitSpark: "LitSpark Solutions पर जाएं"
      }
    },
    // Login Page - Hindi
    login: {
      title: "LitSpark अंडा वितरक डेमो",
      subtitle: "अंडा वितरण व्यवसायों के लिए संपूर्ण प्रबंधन समाधान",
      featuresTitle: "डैशबोर्ड सुविधाएं",
      features: [
        "मार्ग प्रबंधन",
        "दुकान और ग्राहक ट्रैकिंग",
        "सेल्समैन प्रदर्शन",
        "खरीद और इन्वेंट्री",
        "खर्च ट्रैकिंग",
        "लेनदेन रिपोर्ट",
        "दैनिक सारांश",
        "लाभ और हानि एनालिटिक्स"
      ],
      tryDemo: "डेमो आज़माएं",
      signInSubtitle: "सभी सुविधाओं का पता लगाने के लिए साइन इन करें",
      emailLabel: "ईमेल पता",
      emailPlaceholder: "अपना ईमेल दर्ज करें",
      passwordLabel: "पासवर्ड",
      passwordPlaceholder: "अपना पासवर्ड दर्ज करें",
      signIn: "साइन इन",
      signingIn: "साइन इन हो रहा है...",
      whatsappText: "डेमो आज़माना चाहते हैं? हमें WhatsApp संदेश भेजें!",
      whatsappButton: "WhatsApp भेजें"
    },
    // Language Modal - Hindi
    languageModal: {
      title: "अपनी भाषा चुनें",
      subtitle: "अपनी पसंदीदा भाषा चुनें",
      disclaimer: "नोट: कन्नड़ और हिंदी अनुवाद स्वचालित रूप से उत्पन्न किए गए हैं। यदि आपको कोई गलती दिखाई दे, तो कृपया हमें बताएं ताकि हम उन्हें सुधार सकें।",
      continue: "जारी रखें",
      changeLanguage: "भाषा बदलें"
    }
  }
};

export const languages = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
  { code: "hi", name: "Hindi", nativeName: "हिन्दी" }
];
